import {useQuery} from 'react-query';
import {getListFarms} from 'services/farm/listFarms';

const useGetListFarms = () => {
  const {data, isLoading} = useQuery(['this-farms'], getListFarms);
  return {listFarms: data, loadingListFarms: isLoading};
};

export default useGetListFarms;
